export const FormsDigitizationModalTrackingIds = {
  upgradeAction: 'forms-digitization-modal-continue-upgrade-button',
  dismissAction: 'forms-digitization-modal-dismiss-action-button',
};
